import React from "react";
import "./Footer.css";

/**
 * Component that displays the Footer page
 * @param {Object} props - The properties passed to the component.
 * @return {JSX.Element} Footer component JSX
 */
export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="logo-content">
          Copyright © 2023-2024 Green Yogi Naturals Pvt Ltd.
        </div>
        <section className="collapse-content">
          <h5>Customer Service</h5>
          <span>contact@greenyogi.in</span>
        </section>
      </div>
    </footer>
  );
}
